
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import TextFloating from "@/components/input/TextFloating.vue";
import FileInput from "@/components/input/FileInput.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import utils from "@/utils";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import CategoryModel from "@/models/CategoryModel";
import SelectAutocomplete from "@/components/input/SelectAutocomplete.vue";
import ModalAddManpower from "./ModalAddManpower.vue";
import ModalAddMaterial from "./ModalAddMaterial.vue";
import { Ref } from "vue-property-decorator";
import WorkorderModel from "@/models/createTicket/WorkorderModel";
import ResourceModel from "@/models/createTicket/ResourceModel";
import LoadingOverlay from "@/components/overlay/LoadingOverlay.vue";

@Component({
    components: {
        SubHeader,
        Search,
        MenuFooter,
        FileInput,

        ValidationObserver,
        ValidationProvider,
        TextFloating,
        SelectAutocomplete,
        ModalAddMaterial,
        ModalAddManpower,
        LoadingOverlay, 
    },
})
export default class ListNotification extends Vue {
    mounted() {
        this.getDetailTicket(this.$route.params.id);
        this.ticketId = this.$route.params.id;
    }
    utils = utils;
    titlePage = "Additional Resource";
    date = "21/JAN/2022";
    time = "12.30";
    title = "Cake Engine Breaking Down";
    subTitle = "Lorem Ipsum is simply text";
    status = "new";
    isOpen = "0";
    ticket1: ResourceModel = new ResourceModel();
    isActiveDesc = false;
    isActiveMachine = false;
    category: string | null = null;
    theprocess : boolean = false;

    ticketId: string | null = null;

    resource_type: string | null = null;

    listType: { value: string | null; text: string | null }[] = [
        { value: null, text: "Additional Type" },
        { value: "1", text: "Material" },
        { value: "2", text: "Manpower" },
        { value: "3", text: "Material & Manpower" },
    ];

    listCategory: CategoryModel[] = [];
    listMachine: { value: string | null; text: string | null }[] = [];

    step = 0;

    listImage: AttachmentModel[] = [];
    ticket: WorkorderModel = new WorkorderModel();

    @Ref() materialModal!: ModalAddMaterial;
    @Ref() manpowerModal!: ModalAddManpower;

    isTypeActive = false;

    // addMaterial() {
    goBack() {
        this.$router.back();
    }
    cekType() {
        if (this.resource_type !== "") {
            this.isTypeActive = true;
        } else if (this.resource_type === "") {
            this.isTypeActive = false;
        }
    }
    nextPage() {
        this.step = 1;
    }
    step1Submit() {
        if (this.resource_type == "1") {
            // console.log(1)
            this.handleSubmit();
        } else if (this.resource_type == "2") {
            // console.log(2)
            this.handleSubmit();
        } else if (this.resource_type == "3") {
            // console.log(3)
            this.step++;
        }
    }
    step2Submit() {
        if (this.resource_type == "1") {
            // console.log(4)
            this.handleSubmit();
        } else if (this.resource_type == "2") {
            // console.log(5)
            this.handleSubmit();
        } else if (this.resource_type == "3") {
            // console.log(6)
            this.handleSubmit();
        }
    }

    handleSubmit() {
        if(this.theprocess) return
        this.theprocess = true;
        const type = ["material", "manpower", "manpower and material"];
        if(type[Number(this.resource_type) - 1] == "manpower and material"){
            if(this.ticket1.materials.length == 0 || this.ticket1.manpowers.length == 0){
                this.theprocess = false;
                this.$swal("Peringatan", "Material and Manpower must be filled", "warning");
                return;
            }
        }
        if(type[Number(this.resource_type) - 1] == "material"){
            if(this.ticket1.materials.length == 0){
                this.theprocess = false;
                this.$swal("Peringatan", "Material must be filled", "warning");
                return;
            }
        }
        if(type[Number(this.resource_type) - 1] == "manpower"){
            if(this.ticket1.manpowers.length == 0){
                this.theprocess = false;
                this.$swal("Peringatan", "Manpower must be filled", "warning");
                return;
            }
        }
        const data = {
            work_orders_id: Number(this.$route.params.id),
            additional_type: type[Number(this.resource_type) - 1],
            reason: this.ticket1.reason,
            materials: this.ticket1.materials,
            manpowers: this.ticket1.manpowers,
        };
        api.ticket
            .saveResource(data)
            .then((response) => {
                if (response.data.code === 200) {
                    this.$router.back();
                } else {
                    this.theprocess = false;
                    this.$swal("Peringatan", response.data.message, "warning");
                }
            })
            .catch((err: any) => {
                this.theprocess = false;
                this.$swal("Error", err?.response?.data?.message, "error");
            });
    }
    cekDesc() {
        if (this.ticket1.reason !== "") {
            this.isActiveDesc = true;
        } else if (this.ticket1.reason === "") {
            this.isActiveDesc = false;
        }
    }
    saveMaterial(data) {
        // console.log(data);
        this.ticket1.materials.push(data);
    }
    removeMaterial(i: number) {
        this.ticket1.materials.splice(i, 1);
    }
    saveManpower(data) {
        // console.log(data);
        this.ticket1.manpowers.push(data);
    }
    removeManpower(i: number) {
        this.ticket1.manpowers.splice(i, 1);
    }
    addMaterial() {
        this.materialModal.showModal();
    }
    addManPower() {
        this.manpowerModal.showModal("1");
    }
    getDetailTicket(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getDetailTask2(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.ticket = Object.assign({}, response.data.data);
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    // addUploadImgRow() {
    //     const images = new AttachmentModel();
    //     this.ticket1.attachment.push(images);
    // }
    // removeUploadRow(i: number) {
    //     this.ticket1.attachment.splice(i, 1);
    // }
    get colorStatus() {
        if (this.ticket.status === "new") {
            return "cl-red";
        } else {
            return "cl-green-light";
        }
    }
    get pitaStatus() {
        if (this.ticket.status === "new") {
            return "new";
        } else {
            return "on-progress";
        }
    }
}
